// Port of api/fuel/app/classes/filter/search/games/rules/query/has_played.php
import Rule from 'offline/filter/core/search/rule'

export default Rule.create({
	name: 'has_played',
	match: function(rule, config, filter, data, query) {
		query.where('p.user_id', 'in', data.users)

		if (rule.logic.value === 'yes') {
			query.exist('play', 'p')
		} else if (rule.logic.value === 'no') {
			query.notexist('play', 'p')
		}
	}
})
